/**
 * /home (онбординг «Главная») доступна только владельцу кабинета —
 * первому пользователю из регистрации (users_new.is_tenant_owner, в сессии — isTenantOwner).
 * Остальные уходят на свою стартовую страницу.
 */
export const HOME_URL = '/home'
export const DEFAULT_START_PAGE = '/orders'

export function isHomeUrl(url: unknown): boolean {
  return (
    String(url || '')
      .trim()
      .replace(/\/+$/, '')
      .toLowerCase() === HOME_URL
  )
}

/** Стартовая страница с учётом владельца: не-владельцу /home не отдаём. */
export function resolveStartPage(startPage: unknown, isTenantOwner: boolean): string {
  const page = String(startPage || '').trim() || DEFAULT_START_PAGE
  if (!isTenantOwner && isHomeUrl(page)) return DEFAULT_START_PAGE
  return page
}

export const selectIsTenantOwner = (state: any): boolean =>
  Boolean(state?.session?.sessionData?.isTenantOwner)

export const selectStartPage = (state: any): string =>
  resolveStartPage(state?.session?.sessionData?.start_page, selectIsTenantOwner(state))
